import React from "react";
import { render } from "react-dom";
import App from "./components/App.js";
render(<App />, document.getElementById("root"));
